import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import Grid from "@material-ui/core/Grid/Grid";
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import LocationDataRequest from "../../Location/LocationDataRequest";
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import clsx from "clsx";

const useStyles = makeStyles({
    grid: {
        width: 285,
        marginLeft: 20,
    },
    location: {
        width: 120
    },
    zipCode: {
        width: 110,
        paddingLeft: 30
    },
    formControl: {
        width: '100%'
    },
    label: {
        width: 72
    },
    iconCont: {
        cursor: 'pointer',
        width: 35,
        height: 35,
        marginTop: 12,
        marginLeft: 10,
        borderBottom: '1px solid #3f51b4',
    },
    locationIcon: {
        color: '#3f51b4',
        paddingTop: 8,
        paddingLeft: 6,
        fontSize: '1.4rem',
    },
    progressIcon: {
        color: '#3f51b4',
        fontSize: '1.4rem',
        marginTop: 9,
        marginLeft: 8,
    }
});

export default function LocationMobile(props) {

    const [open, setOpen] = React.useState();

    const [counter, setCounter] = React.useState(0);

    const [locationRequested, setLoctionRequested] = React.useState();
    const [locationPayload, setLocationPayload] = React.useState();
    const [zipCodeDefaultValue, setZipCodeDefaultValue] = React.useState();

    const classes = useStyles();

    const params = props.filter.params;

    const filter = props.filter;

    const handleDistanceChange = (e) => {
        params.distance = +e.target.value;
        render();
        filter.dispatchFilter();
    };

    const handleZipCodeChange = (e) => {
        params.zipCode = e.target.value;
        filter.dispatchFilter();
        render();
    };

    const handleClearClick = () => {
        filter.params.distance = 50;
        filter.params.zipCode = null;
        filter.dispatchFilter();
        render();
    };

    const handleOpenClick = () => {
        setOpen(!open);
    };

    const handleConfirm = e => {
        e.preventDefault();
        setOpen(false);
    };

    const handleRequestLocation = () => {
        setLoctionRequested(true);
        navigator.geolocation.getCurrentPosition(handleNavigatorLocation);
    }

    const handleNavigatorLocation = (p) => {
        setLocationPayload(p)
    }

    const onLocationError = () => {
        setLoctionRequested(false);
    }

    const onLocationData = (data) => {
        setLoctionRequested(false);
        params.zipCode = data.zipCode;
        render();
    }

    const render = () => {
        setCounter(counter + 1);
    };

    const years = [];
    for (let i=params.minYearLimit;i<=params.maxYearLimit; i++) {
        years.push(i);
    }

    const distance = params.distance;
    const zipCode = params.zipCode === null ? null : params.zipCode;

    const values = [10, 25, 50, 75, 100, 200, 300, 400, 500, params.distanceLimit];

    return (<>
        {locationRequested && locationPayload
            ? <LocationDataRequest payload={locationPayload} onError={onLocationError} onData={onLocationData}/>
            : null}
        <div className={props.classes.block}>
            <Typography>
                <Grid container className={props.classes.grid}>
                    <Grid item onClick={handleOpenClick}>
                        {open ?
                            <IndeterminateCheckBoxIcon color="primary" className={props.classes.expand}/>
                            : <AddBoxOutlinedIcon color="primary" className={props.classes.expand}/>}
                    </Grid>
                    <Grid item className={classes.label}>Location: </Grid>
                    <Grid item onClick={handleOpenClick} className={
                        clsx(props.isMobile ? props.classes.makeMobile : props.classes.make, props.classes.cutText)}>
                        <a href="#" className={props.classes.value} onClick={(e) => e.preventDefault()}>
                            {params.zipCode && params.distance ? distance+" mil from "+zipCode : "Any"}
                            </a>
                    </Grid>
                    {!open && (params.zipCode && params.distance) ? <div className={props.classes.done} onClick={handleClearClick}>
                        <HighlightOffOutlinedIcon className={props.classes.clear}/>
                    </div> : null}
                    {open ? <div className={props.classes.done}><a href="#" className={props.classes.ok} onClick={handleConfirm}>OK</a></div> : null}
                </Grid>
            </Typography>
            {open ?
            <div className={props.classes.makes}><div className={props.classes.makesCont}>
                <Grid container className={classes.grid}>
                    <Grid item className={classes.location}>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="distance">Search Within</InputLabel>
                            <Select
                                native
                                value={distance}
                                onChange={handleDistanceChange}
                                inputProps={{
                                    name: 'distance',
                                    id: 'distance',
                                }}
                            >
                                {values.map(value => {
                                    return <option value={value} selected={value === distance}>
                                        {value === params.distanceLimit ? "Any Distance" : (value + " Miles")}
                                    </option>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item className={classes.zipCode}>
                        <TextField
                            id="zipCode"
                            label="ZIP Code"
                            value={zipCode ? zipCode : ''}
                            onChange={handleZipCodeChange}
                        />
                    </Grid>
                    <Grid item>
                        <div className={classes.iconCont}>
                            {locationRequested ? <CircularProgress size={20} className={classes.progressIcon}/> :
                                <LocationOnOutlinedIcon className={classes.locationIcon} onClick={handleRequestLocation}/>}
                        </div>
                    </Grid>
                </Grid>
            </div></div> : null}
        </div>
    </>)
}